/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"], n = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"], t = "Tahunan", e = "Tahun", s = "Bulan", o = "Minggu", i = "Hari", r = "Hari", c = "Hari Ini", u = "Tidak Ada Kegiatan", d = "Sepanjang Hari", m = "Hapus", b = "Tambah Kegiatan", g = "dddd, D MMMM YYYY", l = {
  weekDays: a,
  months: n,
  years: t,
  year: e,
  month: s,
  week: o,
  days: i,
  day: r,
  today: c,
  noEvent: u,
  allDay: d,
  deleteEvent: m,
  createEvent: b,
  dateFormat: g
};
export {
  d as allDay,
  b as createEvent,
  g as dateFormat,
  r as day,
  i as days,
  l as default,
  m as deleteEvent,
  s as month,
  n as months,
  u as noEvent,
  c as today,
  o as week,
  a as weekDays,
  e as year,
  t as years
};
